import { useState } from "react";
import { publicAxios } from "../api";
import axios from "axios";
import Swal from "sweetalert2";

function Register() {

  const [formData, setFormData] = useState({
    username: "",
    email: "",
    mobile: "",
    address: "",
    pincode: "",
    latitude: "",
    longitude: "",
    password: "",
    is_customer: true
  });

  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);

  // ------------------------
  // HANDLE INPUT CHANGE
  // ------------------------
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  // ------------------------
  // SIMPLE EMAIL VALIDATION
  // ------------------------
  const isValidEmail = (email) => {
    return /\S+@\S+\.\S+/.test(email);
  };

  // ------------------------
  // FETCH ADDRESS FROM GPS
  // ------------------------
  const getLocation = () => {

    if (!navigator.geolocation) {
      Swal.fire("Error", "GPS not supported", "error");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async (position) => {

        const lat = position.coords.latitude;
        const lon = position.coords.longitude;

        try {
          const res = await axios.get(
            `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}`
          );

          setFormData({
            ...formData,
            latitude: lat,
            longitude: lon,
            address: res.data.display_name
          });

          Swal.fire("Success", "Address fetched successfully", "success");

        } catch {
          Swal.fire("Error", "Failed to fetch address", "error");
        }
      },
      () => Swal.fire("Error", "Location permission denied", "error")
    );
  };

  // ------------------------
  // SEND OTP
  // ------------------------
  const sendOtp = async () => {

    if (!isValidEmail(formData.email)) {
      Swal.fire("Error", "Enter valid email", "warning");
      return;
    }

    await publicAxios.post("send-otp/", {
      email: formData.email
    });

    setOtpSent(true);

    Swal.fire("OTP Sent", "Check your email", "success");
  };

  // ------------------------
  // VERIFY OTP
  // ------------------------
  const verifyOtp = async () => {

    try {
      await publicAxios.post("verify-otp/", {
        email: formData.email,
        otp: otp
      });

      setOtpVerified(true);

      Swal.fire("Verified", "Email verified successfully", "success");

    } catch {
      Swal.fire("Error", "Invalid OTP", "error");
    }
  };

  // ------------------------
  // SUBMIT FORM
  // ------------------------
  const submitForm = async () => {

    if (!otpVerified) {
      Swal.fire("Error", "Verify email first", "warning");
      return;
    }

    if (!formData.address) {
      Swal.fire("Error", "Address is required", "warning");
      return;
    }

    try {
      await publicAxios.post("register/", formData);

      Swal.fire({
        title: "Customer Registered Successfully",
        icon: "success",
        timer: 2000,
        showConfirmButton: false
      });

      window.location.href = "/user-login/";

    } catch (err) {
      Swal.fire("Error", "Registration failed", "error");
    }
  };

  return (

    <section className="container mt-4">

      <h3 className="text-center"
        style={{ color: "white", backgroundColor: "#0dcaf0" }}>
        Customer Registration
      </h3>

      <div className="row mt-4">

        <form>
          <table className="erp-table-modern">
            <tbody>

              {/* USERNAME */}
              <tr>
                <td>User Name</td>
                <td>
                  <input
                    type="text"
                    name="username"
                    value={formData.username}
                    onChange={handleChange}
                  />
                </td>
              </tr>

              {/* EMAIL */}
              <tr>
                <td>Email</td>
                <td>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                  />

                  {!otpSent && (
                    <button
                      type="button"
                      className="btn btn-warning ms-2"
                      onClick={sendOtp}
                    >
                      Send OTP
                    </button>
                  )}

                  {otpVerified && (
                    <span className="text-success ms-2">✔ Verified</span>
                  )}
                </td>
              </tr>

              {/* OTP FIELD */}
              {otpSent && !otpVerified && (
                <tr>
                  <td>Enter OTP</td>
                  <td>
                    <input
                      type="number"
                      value={otp}
                      onChange={(e) => setOtp(e.target.value)}
                    />

                    <button
                      type="button"
                      className="btn btn-success ms-2"
                      onClick={verifyOtp}
                    >
                      Verify OTP
                    </button>
                  </td>
                </tr>
              )}

              {/* MOBILE */}
              <tr>
                <td>Mobile</td>
                <td>
                  <input
                    type="number"
                    name="mobile"
                    value={formData.mobile}
                    onChange={handleChange}
                  />
                </td>
              </tr>

              {/* ADDRESS */}
              <tr>
                <td>Address</td>
                <td>
                  <textarea
                    name="address"
                    value={formData.address}
                    onChange={handleChange}
                    placeholder="Type address or use GPS"
                  />

                  <button
                    type="button"
                    className="btn btn-info ms-2"
                    onClick={getLocation}
                  >
                    <i className="fa-solid fa-location-dot"></i>
                  </button>
                </td>
              </tr>

              {/* PINCODE */}
              <tr>
                <td>Pincode</td>
                <td>
                  <input
                    type="number"
                    name="pincode"
                    value={formData.pincode}
                    onChange={handleChange}
                  />
                </td>
              </tr>

              {/* PASSWORD */}
              <tr>
                <td>Password</td>
                <td>
                  <input
                    type="password"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                  />
                </td>
              </tr>

              {/* SUBMIT */}
              <tr>
                <td colSpan="2" className="text-center">
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={submitForm}
                  >
                    Register
                  </button>
                </td>
              </tr>

            </tbody>
          </table>
        </form>

      </div>
    </section>
  );
}

export default Register;
